import React from 'react';

export default function Checkmark() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g clipPath="url(#a)">
        <path fill="#24AB4A" d="M10.5 16 6 11.5l0.707 -0.707 3.793 3.793 6.793 -6.793L18 8.5z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M4 4h16v16H4z" />
        </clipPath>
      </defs>
    </svg>
  );
}
